import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hidden lg:block w-next-nav fixed h-menu bg-next-dark-gray z-10" }
const _hoisted_2 = { class: "grid grid-rows-7 h-full" }
const _hoisted_3 = { class: "flex-grow grid grid-rows-6 row-span-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_ProfileMenuButton = _resolveComponent("ProfileMenuButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_MenuButton, {
        to: {name:'Home'},
        "icon-class": "icon-home",
        tooltip: "Home"
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_MenuButton, {
          to: {name:'ListaFornitori'},
          "icon-class": "icon-catena_orizzontale",
          tooltip: "Fornitori"
        }),
        (_ctx.fid)
          ? (_openBlock(), _createBlock(_component_MenuButton, {
              key: 0,
              to: {name:'DettaglioFornitore', params: {fid: _ctx.fid}},
              "icon-class": "icon-catena_verticale",
              tooltip: "Fornitrore"
            }, null, 8, ["to"]))
          : _createCommentVNode("", true),
        (_ctx.fid && _ctx.hasPermission('approve fornitori'))
          ? (_openBlock(), _createBlock(_component_MenuButton, {
              key: 1,
              to: {name:'FornitoreAudit', params: {fid: _ctx.fid}},
              "icon-class": "icon-orologio_freccia",
              tooltip: "Modifiche"
            }, null, 8, ["to"]))
          : _createCommentVNode("", true),
        _createVNode(_component_ProfileMenuButton, {
          class: "row-start-6",
          notification: _ctx.meCounters?.notification_counter > 0
        }, null, 8, ["notification"])
      ])
    ])
  ]))
}